



import Vue from 'vue';
import Component from 'vue-class-component';
import { CodeValidation, TenDigitPhoneValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { postConfirmUser, postResendConfirmationCode, putUpdatePhone } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';
import EnrollmentBase from '@/components/EnrollmentBase/EnrollmentBase.vue';

@Component({
	validations: {
		code: CodeValidation.validations(6),
		mobileNumber: TenDigitPhoneValidation.validations(),
	},
	components: {
		EnrollmentBase,
	},
})
export default class VerifyMobileDevice extends Vue {
	code: string = '';

	showExtra: boolean = false;

	mobileNumber: string = '';

	template: string = '';

	sessionExpired: boolean = false;

	timeoutState: string = 'enabled';

	formErrorMessage: string = '';

	verifyBtn: boolean = true;

	changeBtn: boolean = true;

	token: string = '';

	last4Ssn: string = '';

	dateOfBirth: string = '';

	kjwt: string | null = null;

	instructions: string = 'We texted a 6-digit code to your mobile number. Enter it below to confirm your device. Your code is good for 24 hours.';

	formTemplate: string = 'verifyMobile';

	extraLinkText: string = 'Change Mobile Number';

	get codeErrors() {
		return CodeValidation.errors(this, 'code', '6');
	}

	get mobileNumberErrors() {
		return TenDigitPhoneValidation.errors(this, 'mobileNumber');
	}

	created() {
		this.template = 'verify';
		this.token = sessionStorage.getItem('token') || '';
		this.last4Ssn = sessionStorage.getItem('last4Ssn') || '';
		this.dateOfBirth = sessionStorage.getItem('dateOfBirth') || '';
		this.$root.$on('extraLinkVerifyMobile', this.changeView);
	}

	async verify() {
		this.$v.code.$touch();
		if (!this.$v.code.$invalid) {
			this.verifyBtn = false;
			this.formErrorMessage = '';
			const token: string = sessionStorage.getItem('token') || '';
			const last4Ssn: string = sessionStorage.getItem('last4Ssn') || '';
			const dateOfBirth: string = sessionStorage.getItem('dateOfBirth') || '';
			try {
				await postConfirmUser({
					token,
					// eslint-disable-next-line @typescript-eslint/camelcase
					ssn_last_4: last4Ssn,
					// eslint-disable-next-line @typescript-eslint/camelcase
					date_of_birth: dateOfBirth,
					// eslint-disable-next-line @typescript-eslint/camelcase
					confirmation_code: this.code,
				});
				this.userConfirmed();
			} catch (error) {
				this.userConfirmedError(error.response.status);
			} finally {
				this.verifyBtn = true;
			}
		}
	}

	userConfirmed() {
		this.$router.push({ name: 'pinSetup' });
	}

	userConfirmedError(status: string) {
		let errorMessage = 'An unknown error has occurred.';
		switch (status) {
			case '400':
				errorMessage = 'Confirmation code is incorrect';
				break;
			default:
				break;
		}
		this.formErrorMessage = errorMessage;
	}

	resendCode() {
		try {
			postResendConfirmationCode({
				token: this.token,
				// eslint-disable-next-line @typescript-eslint/camelcase
				ssn_last_4: this.last4Ssn,
				// eslint-disable-next-line @typescript-eslint/camelcase
				date_of_birth: this.dateOfBirth,
			});
			this.code = '';
			(this.$refs.code as HTMLInputElement).focus();
		} catch (error) {
			let message = 'There was an error resending your code.';
			if (error.response.error && error.response.error.message) {
				message = error.response.error.message;
			}
			this.formErrorMessage = message;
		}
	}

	changeView(template?: 'change' | 'verify') {
		if (!template) {
			// eslint-disable-next-line no-param-reassign
			template = (this.template === 'change') ? 'change' : 'verify';
		}

		this.formErrorMessage = '';
		switch (template) {
			case 'change':
				this.extraLinkText = 'Change Mobile Number';
				this.showVerifyMobile();
				break;
			default:
				this.extraLinkText = 'Cancel Change Mobile Number';
				this.showChangeMobile();
				break;
		}
	}

	showChangeMobile() {
		this.kjwt = sessionStorage.getItem('kjwt');
		const timeout = sessionStorage.getItem('enrollmentTouch');
		if (this.kjwt && (Number(timeout) <= new Date().valueOf())) {
			const headline = 'Change Mobile Number.';
			this.timeoutState = 'reset'; // resets session expired timer
			this.instructions = 'Enter your new number below. We\'ll text you a 6-digit code to verify. SMS rates may apply.';
			this.$store.commit('setHeadline', headline);
			this.timeoutState = 'enabled'; // set to default state so the timer does not keep updating
			this.template = 'change';
		} else {
			this.sessionExpired = true;
		}
	}

	showVerifyMobile() {
		const headline = 'Verify your mobile device.';
		this.instructions = 'We texted a 6-digit code to your mobile number. Enter it below to confirm your device. Your code is good for 24 hours.';
		this.$store.commit('setHeadline', headline);
		this.template = 'verify';
	}

	async change() {
		this.$v.mobileNumber.$touch();
		if (!this.$v.mobileNumber.$invalid) {
			this.changeBtn = false;
			try {
				await putUpdatePhone(
					this.mobileNumber,
					{
						kjwt: String(this.kjwt),
					},
				);
				this.extraLinkText = 'Change Mobile Number';
				this.changeView('change');
			} catch (error) {
				this.formErrorMessage = 'An unknown error has occurred.';
			} finally {
				this.changeBtn = true;
			}
		}
	}

	mobileInput($event: { target: { unmaskedValue: string }}) {
		this.mobileNumber = $event.target.unmaskedValue;
	}

	beforeDestroy() {
		this.token = '';
		this.last4Ssn = '';
		this.dateOfBirth = '';
	}
}
